var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-float-download-base-component",style:({ top: (_vm.top + "px") })},[_c('img',{attrs:{"src":_vm.qrcode}}),_c('p',[_vm._v("Scan to download")])])}
var staticRenderFns = []

export { render, staticRenderFns }